import {Modal} from './Modal';
import {REQUEST_CLASS} from '../Library/HtmxRequestState';
import {cloneButtonSpinner} from '../Library/LoadingIndicator';

const NAVIGATION_HEADERS = ['HX-Redirect', 'HX-Refresh'];

const pendingModals = new WeakMap();

const buildBody = (text) => {
    const body = document.createElement('div');

    for (const paragraph of text.split(/\n\n+/)) {
        const element = document.createElement('p');
        element.textContent = paragraph;
        body.appendChild(element);
    }

    return body;
};

const buildConfirmButton = ({buttonText, variant, onConfirm}) => {
    const button = document.createElement('button');
    button.className = variant;
    button.type = 'button';
    button.append(cloneButtonSpinner(), buttonText);
    button.addEventListener('click', onConfirm);

    return button;
};

const holdUntilResponse = (element, modal) => {
    if (!element.classList.contains(REQUEST_CLASS)) {
        modal.hide();

        return;
    }

    modal.lock();
    pendingModals.set(element, modal);
};

export const openConfirmModal = (element, proceed) => {
    const {confirmTitle, confirmBody, confirmButtonText, confirmVariant} = element.dataset;

    let modal;

    const handleConfirm = () => {
        proceed();
        holdUntilResponse(element, modal);
    };

    modal = Modal({
        title: confirmTitle,
        content: buildBody(confirmBody),
        footer: buildConfirmButton({
            buttonText: confirmButtonText,
            variant: confirmVariant,
            onConfirm: handleConfirm,
        }),
        onConfirm: handleConfirm,
    });

    modal.render();
};

export const hideConfirmedModal = event => {
    const {requestConfig: {elt}, xhr} = event.detail;
    const modal = pendingModals.get(elt);

    if (!modal) {
        return;
    }

    pendingModals.delete(elt);

    if (NAVIGATION_HEADERS.some(header => xhr.getResponseHeader(header))) {
        return;
    }

    modal.hide();
};

export const confirmFormSubmission = (event) => {
    const form = event.detail.elt;

    if (!(form instanceof HTMLFormElement) || !form.dataset.confirmTitle) {
        return;
    }

    event.preventDefault();

    openConfirmModal(form, () => event.detail.issueRequest(true));
};
